module.exports = __webpack_public_path__ + "img/publish.46b9920b.svg";